<template>
  <div class="spin-info"
    :style="{'background': spinControlBackground, 'color': spinControlIconsColor}"
  >
    {{ text }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SpinInfo',
  props: {
    text: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      spinControlBackground: 'spinControl/spinControlBackground',
      spinControlIconsColor: 'spinControl/spinControlIconsColor'
    })
  }
}
</script>

<style lang="scss" scoped>
.spin-info {
  position: absolute;
  right: 0;
  top: -40px;
  max-width: 150px;
  width: 100%;
  min-height: 40px;
  background-color: rgba(50, 123, 186, .15);
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
}
</style>
